import {Component, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {routerTransition} from '@app/router.animations';
import {CommonModule, DatePipe} from '@angular/common'
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {OrderService} from '@app/shared/services/order.service';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-supplier-price',
  templateUrl: './supplier-price.component.html',
  styleUrls: ['./supplier-price.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    NgbHighlight,
    SelectDropDownModule,
    NgbTypeahead
  ],
  providers: [DatePipe]
})
export class SupplierPriceComponent implements OnInit {


  user_rights: any;
  user_data: any;

  public supplier_price_details: any = [""];
  public supplier_price: any =
    {
      vendor_id: '',
      medicine_data: [],
      item_id: '',
      item_price: '',
      fromdate: new Date(),
      todate: '',
      user_id: '',
      vat_price: 0,
      vat_amount: '',
      total: ''
    }
  searching = false;
  searchFailed = false;
  date: any;
  unit: any;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  vendor: any;
  vendor_options: any;
  vendor_data: any;
  save_status: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  vat: any;

  constructor(private loaderService: LoaderService,
              public orderService: OrderService,
              public consultingService: ConsultingService,
              public utils: UtilsInjectable,
              private toastr: ToastrService) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.supplier_price.user_id = this.user_data.user_id;
    this.getDropdowns();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public selectVatprice(val: any) {
    this.supplier_price.vat_price = val;
  }

  getVendor(data: any) {
    this.supplier_price.vendor_id = data['value'].VENDOR_ID;
  }

  public set_item_medicine($event: any) {
    const item = $event.item;
    this.supplier_price.item_id = item.MEDICINE_ID;
    this.vat = parseFloat(item.VAT);

    this.getMedicine(item);

  }

  public clear_purchase() {
    this.supplier_price_details = ["0"];
    this.supplier_price = {
      vendor_id: '',
      medicine_data: [],
      item_id: '',
      item_price: '',
      fromdate: new Date(),
      todate: '',
      user_id: '',
      vat_price: 0,
      vat_amount: ''

    }
    this.vendor_data = ""
    this.getDropdowns();
  }

  public saveSupplierPrice(): any {

    if (this.supplier_price.vendor_id == '') {
      this.toastr.error('Please select a Supplier !');
      return false;
    }
    if (this.supplier_price.item_id == '') {
      this.toastr.error('Please select a Item !');
      return false;
    }
    if (this.supplier_price.item_price == '') {
      this.toastr.error('Please enter price !');
      return false;
    }
    if (this.supplier_price.vat_price == 1) {

      const item_price = (parseFloat(this.supplier_price.item_price) / (100 + (this.vat)) * 100);
      this.supplier_price.vat_amount = (parseFloat(this.supplier_price.item_price) - item_price).toFixed(2);
      this.supplier_price.item_price = item_price
      this.supplier_price.total = (parseFloat(this.supplier_price.item_price) + parseFloat(this.supplier_price.vat_amount)).toFixed(2)
    }

    if (this.supplier_price.vat_price == 0) {
      this.supplier_price.vat_amount = (parseFloat(this.supplier_price.item_price) * this.vat / 100).toFixed(2);
      this.supplier_price.total = (parseFloat(this.supplier_price.item_price) + parseFloat(this.supplier_price.vat_amount)).toFixed(2);
    }

    this.loaderService.display(true);
    this.orderService.saveSupplierPrice(this.supplier_price).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.save_status = result["status"];
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.clear_purchase();

      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public getMedicine(data: any) {
    const postData = {
      medicine_id: data.MEDICINE_ID
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.getMedicine(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        const medilist_data = result['data'];
        this.supplier_price.item_id = medilist_data.MEDICINE_ID;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }

    });
  }

  public getDropdowns() {
    const postData = {
      vendor_id: ''
    }
    this.loaderService.display(true);
    this.orderService.listVendor(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.vendor = result['data'];
        this.vendor_options = this.vendor;
        for (let index = 0; index < this.vendor_options.length; index++) {
          if (this.vendor_options[index].VENDOR_ID == this.supplier_price.vendor_id) {
            this.vendor_data = this.vendor_options[index];

          }
        }
      }
    });

  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.orderService.price_medicine_search(term).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: { TRADE_NAME: string, PRODUCT_CODE: string, MEDICINE_ID: number }): any => x.TRADE_NAME;
}
